import React from 'react';
import { useCurrentTasks } from '../../hooks/useCurrentTasks';
import JiraPanel from './JiraPanel';
import './JiraPage.css';

/**
 * Full-page wrapper for the Jira board.
 * Resolves the intranet user so the panel gets the employee id (for local
 * time tracking) and the admin flag (for the connection wizard).
 */
const JiraPage: React.FC = () => {
  const { user: intranetUser } = useCurrentTasks();

  return (
    <div className="jira-page">
      <div className="jira-page-bg" aria-hidden="true" />
      <JiraPanel
        userId={intranetUser?.id}
        isAdmin={intranetUser?.isAdmin === true}
      />
    </div>
  );
};

export default JiraPage;
